<template>
  <div class="task-log" v-loading="viewLoading">
    <div class="task-log-item" v-for="item in logList" :key="item.log_id">
      <div class="task-log-item-head">
        <Myavatar width="28px" height="28px" :userName="item.message_sender_user.realname" :imgUrl="item.message_sender_user.user_avatar">{{item.message_sender_user.realname}}</Myavatar>
        <!-- <span>{{item.message_sender_user.realname}}</span> -->
        <span class="date">{{item.create_time}}</span>
      </div>
      <p class="message-model" v-html="getTaskModel(item)"></p>
    </div>
    <nothing
      v-if="!logList || logList.length == 0"
      :width="'125px'"
      :config="{
        type: 'img_no_news_notification',
        tip: '暂无日志'
      }"
    ></nothing>
    <!-- <div class="not-msg" v-if="!logList || logList.length == 0">— 暂无日志 —</div> -->
  </div>
</template>

<script>
import dayjs from "dayjs";
export function formatDate(timestamp) {
  return dayjs(timestamp).format("YYYY-MM-DD");
}
export function formatTime(timestamp) {
  return dayjs(timestamp).format("HH:mm");
}
import dynamicApi from '@/services/api/dynamic/dynamic'
export default {
  name: "Log",
  props: {
    taskId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      comment: "",
      page: 1,
      limit: 1000,
      logList: [],
      viewLoading: false
    }
  },
  created() {
    this.taskId && this.fetchTaskLog();
  },
  methods: {
    async fetchTaskLog() {
      this.viewLoading = true
      let result = await dynamicApi.getDynamicList({
        task_id: this.taskId,
        page: this.page,
        number: this.limit
      })
      this.logList = result.data
      this.viewLoading = false
    },
    getCodeKey(item) {
      let str = item.remarks.replace(/[ ]/g, "&nbsp;")
      let task = str.match(/%%(.+?)%%+/g)
      let storngTxt = str.match(/%b(.+?)%b/g)
      if (task) {
        task.forEach(res => {
          str = str.replace(res, `<span class="person">${res.split('%%')[1]}</span>`)
        })
      }
      if (storngTxt) {
        storngTxt.forEach(res => {
          str = str.replace(res, `<span class="person">${res.split('%b')[1]}</span>`)
        })
      }
      str = str.replace('&title&', `<span class="person">${item.title}</span>`)
      str = `<span class="person">${item.username}</span>` + str
      return str
    }

  },
  watch: {
    taskId: {
      handler: function (newVal) {
        if (newVal) {
          this.fetchTaskLog();
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
